import { z } from 'zod';
/**
 * Upper bounds are generous (8 KB) but defend against DoS by clients posting
 * huge blobs into the users/channel key fields.
 */
const MAX_KEY_FIELD = 8 * 1024;
// Base64 only — no path traversal, no control chars.
const base64 = z
    .string()
    .min(1)
    .max(MAX_KEY_FIELD)
    .regex(/^[A-Za-z0-9+/=]+$/, 'Must be a base64 string');
export const keyBundleSchema = z.object({
    publicKey: base64,
    encryptedPrivateKey: base64,
    keyDerivationSalt: base64,
});
export const channelKeyShareSchema = z.object({
    keys: z
        .array(z.object({
        userId: z.string().uuid(),
        encryptedChannelKey: base64,
    }))
        .min(1)
        .max(500),
});
export const singleChannelKeyShareSchema = z.object({
    encryptedChannelKey: base64,
});
/**
 * Sealed channel keys an owner/admin shares with ONE existing member (a joiner),
 * one per epoch. Epoch numbers must be unique in a request.
 */
export const memberKeySharesSchema = z.object({
    /**
     * The `joinedAt` the add-member call returned. The share only applies to THAT
     * membership: if the member was removed and re-added meanwhile (possibly with
     * a different history choice) the share is refused, not applied to the new one.
     */
    membershipJoinedAt: z.string().datetime(),
    /**
     * The admin's explicit choice: true = the keys MAY open messages sent before
     * the join (history). The server refuses a share that would, unless this is
     * true, so a stale or modified client cannot grant history by accident.
     */
    allowHistory: z.boolean(),
    keys: z
        .array(z.object({
        epoch: z.number().int().min(0),
        encryptedChannelKey: base64,
    }))
        .min(1)
        .max(200)
        .refine((keys) => new Set(keys.map((k) => k.epoch)).size === keys.length, {
        message: 'Each epoch may appear only once',
    }),
});
//# sourceMappingURL=key.schema.js.map